var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDropUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70175 13.7018L6.70175 10.7018C6.89474 10.5263 7 10.2807 7 10C7 9.45614 6.54386 9 6 9C5.7193 9 5.47368 9.10526 5.29825 9.29825L2.29825 12.2982C2.10526 12.4737 2 12.7193 2 13C2 13.5439 2.45614 14 3 14C3.2807 14 3.52632 13.8947 3.70175 13.7018ZM5.29825 10.7018L8.29825 13.7018C8.47368 13.8947 8.7193 14 9 14C9.54386 14 10 13.5439 10 13C10 12.7193 9.89474 12.4737 9.70175 12.2982L6.70175 9.29825C6.52632 9.10526 6.2807 9 6 9C5.45614 9 5 9.45614 5 10C5 10.2807 5.10526 10.5263 5.29825 10.7018ZM9 12H3C2.45614 12 2 12.4561 2 13C2 13.5439 2.45614 14 3 14H9C9.54386 14 10 13.5439 10 13C10 12.4561 9.54386 12 9 12ZM3 13H9L6 10L3 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropUp);
export default __webpack_public_path__ + "static/media/arrow_drop_up.77fd776c.svg";
export { ForwardRef as ReactComponent };